import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import RawMarkup from '../../../common/RawMarkup';

const NosotrosHero = ({ data }) => {
    if (!data) return null;
    const { title, subtitle, description, buttonText, buttonLink } = data;

    return (
        <Box sx={{ 
            py: { xs: 8, md: 10 }, 
            bgcolor: '#eff2f9', 
            textAlign: 'center'
        }}>
            <Container maxWidth="lg">
                <Typography 
                    variant="h2" 
                    component="h1" 
                    sx={{ 
                        mb: 3, 
                        fontWeight: 800, 
                        color: '#4e429c',
                        fontSize: { xs: '2.5rem', md: '3.8rem' }
                    }}
                >
                    <RawMarkup content={title} />
                </Typography>
                
                <Typography 
                    variant="h5" 
                    sx={{ 
                        mb: 2, 
                        fontWeight: 700, 
                        color: '#444',
                        maxWidth: '900px',
                        mx: 'auto',
                        fontSize: { xs: '1.2rem', md: '1.6rem' },
                        lineHeight: 1.2
                    }}
                >
                    {subtitle}
                </Typography>

                <Typography 
                    variant="body1" 
                    sx={{ 
                        mb: 4, 
                        maxWidth: '900px', 
                        mx: 'auto',
                        color: '#666',
                        fontSize: { xs: '1rem', md: '1.2rem' },
                        lineHeight: 1.4
                    }}
                >
                    <RawMarkup content={description} />
                </Typography>

                {buttonText && (
                    <Box sx={{ mb: 6 }}>
                        <Button 
                            variant="contained" 
                            size="large" 
                            href="/assets/docs/E2E_Travel_Solutions_Presentation.pdf"
                            download="E2E_Travel_Solutions_Presentation.pdf"
                            sx={{ 
                                bgcolor: '#f4b436', 
                                '&:hover': { bgcolor: '#e0a12e' },
                                borderRadius: '50px',
                                px: 4,
                                py: 1.2,
                                textTransform: 'none',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                boxShadow: 'none'
                            }}
                        >
                            {buttonText}
                        </Button>
                    </Box>
                )}

                {data.footerText && (
                    <Typography
                        variant="body1"
                        sx={{
                            fontStyle: 'italic',
                            color: '#555',
                            fontSize: { xs: '0.9rem', md: '1.1rem' },
                            fontWeight: 300,
                            letterSpacing: '0.02em',
                            opacity: 0.8
                        }}
                    >
                        {data.footerText}
                    </Typography>
                )}
            </Container>
        </Box>
    );
};

export default NosotrosHero;
